import type { LocationQueryValue, RouteLocationGeneric, RouteLocationNormalizedLoaded, RouteLocationRaw } from 'vue-router'
import router from '@/router'
import { parsePositiveInt } from '@/utils/common.utils'

export function getQueryParam(value: LocationQueryValue | LocationQueryValue[]): string {
  return Array.isArray(value) ? (value[0] ?? '') : (value ?? '')
}

export function getQueryIdParam(value: LocationQueryValue | LocationQueryValue[]): number | null {
  return parsePositiveInt(getQueryParam(value))
}

export function navigateToWorkspace(to: RouteLocationRaw, currentWorkspaceId?: number, notificationWorkspaceId?: number) {
  if (currentWorkspaceId && currentWorkspaceId === notificationWorkspaceId) {
    router.push(to)
  }
  else if (notificationWorkspaceId) {
    const resolved = router.resolve(to)

    assignWorkspacePath(resolved, notificationWorkspaceId)
  }
}

export function navigateToWorkspaceByRoute(route: RouteLocationNormalizedLoaded, workspaceId: number) {
  const location = routeRedirectLocation(route)

  assignWorkspacePath(location, workspaceId)
}

function assignWorkspacePath(generic: RouteLocationGeneric, workspaceId: number) {
  location.assign(`/w/${workspaceId}${generic.fullPath}`)
}

export function routeRedirectLocation(route: RouteLocationNormalizedLoaded): RouteLocationGeneric {
  switch (route.name) {
    case 'transport-view-id':
    case 'transport-edit-id':
      return router.resolve({ name: 'transport-list' })
    case 'request-view-id':
    case 'request-edit-id':
    case 'request-copy-id':
      return router.resolve({ name: 'request-list' })
    default:
      return route
  }
}
